import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useMaintenance } from '../context/MaintenanceContext';
import MaintenancePage from '../pages/MaintenancePage';

const AUTH_PATHS = ['/login', '/register', '/forgot-password', '/reset-password'];

function normalizeRole(value) {
  return String(value || '').toLowerCase();
}

export default function MaintenanceGuard({ children }) {
  const location = useLocation();
  const { user, loading: authLoading } = useAuth();
  const { enabled, allowedRoles, loading: maintenanceLoading } = useMaintenance();

  const pathname = location.pathname || '/';

  const isAuthPath = useMemo(() => {
    return AUTH_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  }, [pathname]);

  const roleName = normalizeRole(user?.role_name || user?.role);
  const canBypass = useMemo(() => {
    if (!roleName) return false;
    const allowed = Array.isArray(allowedRoles) ? allowedRoles : ['admin'];
    return allowed.map(normalizeRole).includes(roleName);
  }, [allowedRoles, roleName]);

  if (maintenanceLoading) {
    return children;
  }

  if (enabled && !canBypass) {
    if (isAuthPath || authLoading) {
      return children;
    }
    return <MaintenancePage />;
  }

  return children;
}
